/******/ (() => { // webpackBootstrap
/* eslint-disable */
if (!customElements.get('variant-dropdown')) {
  customElements.define('variant-dropdown',
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();

      /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
      ['onDocumentClick', 'handleOptionKeyDown', 'closeDropdownOnFocusOut'].forEach((fn) => {
        this[fn] = this[fn].bind(this);
      });
    }

    connectedCallback() {
      /* ===== Cache the DOM elements and attach the event listeners ===== */
      this.cacheDOMElements();
      this.addEventListeners();
    }

    cacheDOMElements() {
      this.dropdownButton = this.querySelector('[data-dropdown-button]');
      this.dropdownList = this.querySelector('[data-dropdown-list]');
      this.selectedOptionDisplay = this.querySelector('[data-selected-option]');
      this.options = this.dropdownList.querySelectorAll('li');
      this.productForm = this.closest('product-information');
      this.sectionId = this.getAttribute('data-section-id');
      
      const activeSwatches = document.querySelectorAll("li.dropdown-list--item.selected");
    //   activeSwatches.forEach(swatch => {
    //   const swatchValue = swatch.getAttribute("data-optionswatch");
      this.setGlobalElement(activeSwatches);
      
    // });
      

    }

    addEventListeners() {
      /* ===== Attach the event listeners to the DOM elements ===== */
      this.dropdownButton.addEventListener('click', () => this.toggleDropdown());
      this.options.forEach(option => {
        option.addEventListener('click', () => this.handleOptionClick(option));
        option.addEventListener('keydown', this.handleOptionKeyDown);
        
      });

      this.dropdownList.addEventListener('focusout', this.closeDropdownOnFocusOut);
      document.addEventListener('click', this.onDocumentClick);
      
    }

    handleOptionKeyDown(event) {
      /* ===== Handle the keydown event on the dropdown options ===== */
      if (event.key === 'Enter') {
        this.handleOptionClick(event.target);
      }
    }

    closeDropdownOnFocusOut() {
      /* ===== Use setTimeout to delay the check because the new focus target is not yet focused ===== */
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.updateButtonStates();
          this.updateDropdownClasses(true);
          this.closeDropdown();
        }
      }, 0);
    }

    handleOptionClick(option) {
      /* ===== Handle the click event on the dropdown options ===== */
      this.updateOptionLabel(this.selectedOptionDisplay, option); // Update the display area with this option's text
      this.markOptionAsSelected(option); // Update the 'selected' state 
      this.toggleDropdown(); // Close the dropdown
      this.onOptionChange(option); // Dispatch a custom event to notify the parent component that the selected option has changed
      
    }

    toggleDropdown() {
      /* ===== Toggle the dropdown open and closed ===== */
      const isOpen = this.dropdownList.style.display === 'block';
      this.updateButtonStates();
      
      if (isOpen) {
        this.dropdownButton.focus();
        this.updateDropdownClasses(isOpen);
        this.closeDropdown(); 
      } else {
        this.dropdownList.querySelector('li').focus();
        this.dropdownList.style.display = 'block';
        setTimeout(() => this.updateDropdownClasses(isOpen), 50); // Toggle the open state classes with a short delay to allow the dropdown to animate
      }
    }

    onOptionChange(option) {
      const dropdownId = option.getAttribute('data-dropdown-id');
      const productUrl = option.getAttribute('data-product-url');
      const productFetchUrl = option.getAttribute('data-product-fetch-url');
      const currentVariant = this.getVariantData(dropdownId);
      const isCombinedListing = option.getAttribute('data-is-combined-listing') === 'true';

      // if (currentVariant.option2 == "No Engraving") {
      //   document.getElementById('fontFamilySelect').setAttribute("name", '');
      // } else {
      //   document.getElementById('fontFamilySelect').setAttribute("name", 'properties[font]');
      // }
      this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
    }

    emitVariantChangeEvent(variant, productFetchUrl, productUrl, isCombinedListing = false) {
      /* ===== Emit the variant:change event ===== */
      eventBus.emit('variant:change', {
        sectionId: this.sectionId,
        variant: variant,
        fetchURL: productFetchUrl,
        productURL: productUrl,
        isCombinedListing: isCombinedListing
      });
    } 

    updateOptionLabel(currentLabelElement, newLabelElement) {
      /* ===== Update the display area with the new option's text ===== */
      const newLabel = newLabelElement.querySelector('.option-label').textContent;
      currentLabelElement.textContent = newLabel;
      
    }

    updateDropdownClasses(isOpen) {
      /* ===== Update the dropdown classes to open or close the dropdown ===== */
      const action = isOpen ? 'remove' : 'add';
      this.classList[action]('variant-dropdown--open');
      this.dropdownList.classList[action]('variant-dropdown-fade-enter-active', 'variant-dropdown-fade-enter-to', 'variant-dropdown-fade-enter');
      this.dropdownList.classList[action === 'add' ? 'remove' : 'add']('variant-dropdown-fade-leave-active', 'variant-dropdown-fade-leave-to', 'variant-dropdown-fade-enter');
    }

    updateButtonStates() {
      /* ===== Update the button states based on the dropdown open or closed state ===== */
      const isOpen = this.dropdownList.style.display === 'block';
      const ariaExpanded = isOpen ? 'false' : 'true';
      this.dropdownButton.setAttribute('aria-expanded', ariaExpanded);
    }

    markOptionAsSelected(option) {
      /* ===== Mark the selected option as 'selected' and remove the 'selected' state from all other options ===== */
      this.options.forEach(opt => {
        opt.removeAttribute('selected');
        opt.classList.remove('selected');
      });
      option.setAttribute('selected', '');
      option.classList.add('selected');
    }

    
  setGlobalElement(activeSwatches) {
    this.arabicFourSideHandle(activeSwatches);
  const personalizeContainer = document.getElementById("personalize_container");
  if (!personalizeContainer || personalizeContainer.getAttribute("data-personalize") !== "true") return;

  const reverseContent = document.getElementById("ReverseOnlyContent");
  const reverseInput = reverseContent.querySelector("input");
  const frontOnly = document.getElementById("frontOnly");
  const frontInput = frontOnly.querySelector("input");
  const customEditorForm = document.getElementById("customEditorFormFont");
  const personalizeInput = document.getElementById("personalize");
  const customEditorInput = document.getElementById("customEditor");

  // Reset values and hide all by default
  personalizeInput.value = "";
  customEditorInput.value = "";
  
  //customEditorForm.style.display = "none";
  frontOnly.style.display = "none";
  reverseContent.style.display = "none";
  frontInput.removeAttribute("required");
  reverseInput.removeAttribute("required");

    let option1Value = null;
      let option2Value = null;
      
      activeSwatches.forEach(swatch => {
        const swatchValue = swatch.getAttribute("data-optionswatch");
        const optionName = swatch.closest('.dropDown').getAttribute("data-option-name");
      
        if (optionName === 'Option1') {
          option1Value = swatchValue;
        } else if (optionName === 'Option2') {
          option2Value = swatchValue;
        }
      });

      console.log('option1Value', option1Value, 'option2Value', option2Value)

      const optionValues = [option1Value, option2Value];
// Now loop through each selected value and show/hide sections accordingly
optionValues.forEach(data => {
  if (!data) return; // skip if value is null or undefined

  const isReverse = ["reverse-only", "reverse", "reverse-side-only", "reverse-side"].includes(data);
  const isFront = ["front-only", "front", "front-side-only", "front-side"].includes(data);
  const isBoth = ["both-sides-engraving", "both-sides", "bothside"].includes(data);

    // Show reverse content if applicable
  if (isReverse) {
    reverseContent.style.display = "block";
    frontOnly.style.display = "none";
    reverseInput.setAttribute("required", "required");
  }

  // Show front content if applicable
  if (isFront) {
    frontOnly.style.display = "block";
    reverseContent.style.display = "none";
    frontInput.setAttribute("required", "required");
    
  }
    // If any of these match, show the main custom editor form
  if (isBoth) {
    reverseContent.style.display = "block";
    frontOnly.style.display = "block";
    reverseInput.setAttribute("required", "required");
  }
  // // If any of these match, show the main custom editor form
  // if (isReverse || isFront || isBoth) {
  // if (customEditorForm) {
  //   customEditorForm.style.display = "block";
  //   }
  // }

  // // Show reverse content if applicable
  // if (isReverse || isBoth) {
  //   reverseContent.style.display = "block";
  //   reverseInput.setAttribute("required", "required");
  // }

  // // Show front content if applicable
  // if (isFront || isBoth) {
  //   frontOnly.style.display = "block";
  //   frontInput.setAttribute("required", "required");
  // }
});
  
}
arabicFourSideHandle(engraving){
      // 1-side-engraving
      
        const personalizeContainer = document.getElementById("personalize_container");
  if (!personalizeContainer || personalizeContainer.getAttribute("data-personArabic") !== "true") return;

      let option1Value = null;
      let option2Value = null;
      let option3Value = null;
      
      engraving.forEach(swatch => {
        const swatchValue = swatch.getAttribute("data-optionswatch");
        const optionName = swatch.closest('.dropDown').getAttribute("data-option-name");
      
        if (optionName === 'Option1') {
          option1Value = swatchValue;
        } else if (optionName === 'Option2') {
          option2Value = swatchValue;
        }else if (optionName === 'Option3') {
          option3Value = swatchValue;
        }
      });

      console.log('option1Value', option1Value, 'option2Value', option2Value)

      const optionValues = [option1Value, option2Value, option3Value];
      optionValues.forEach(data => {
        if (!data) return; // skip if null/undefined
        const isSideEng = ["1-side-engraving", "one-side"].includes(data);
        const isTwoSideEng = ["2-sides-engraving","two-side", "both-sides"].includes(data);
        const isThreeSideEng = ["3-sides-engraving", "three-side"].includes(data);
        const isFourSideEng = ["4-sides-engraving", "four-side"].includes(data);
        if (isSideEng) {
          document.getElementById("oneside").style.display = "block";
          document.getElementById("fourside").style.display = "none";
          document.getElementById("twoside").style.display = "none";
          document.getElementById("threeside").style.display = "none";
        }
      
        if (isTwoSideEng) {
          document.getElementById("twoside").style.display = "block";
          document.getElementById("oneside").style.display = "none";
          document.getElementById("fourside").style.display = "none";
          document.getElementById("threeside").style.display = "none";
        }
        if (isThreeSideEng) {
          document.getElementById("threeside").style.display = "block";
          document.getElementById("oneside").style.display = "none";
          document.getElementById("twoside").style.display = "none";
          document.getElementById("fourside").style.display = "none";
        }
        if (isFourSideEng) {
          document.getElementById("fourside").style.display = "block";
          document.getElementById("oneside").style.display = "none";
          document.getElementById("twoside").style.display = "none";
          document.getElementById("threeside").style.display = "none";
        }
      });
    }
    
    onDocumentClick(event) {
      /* ===== Close the dropdown when the user clicks outside of the dropdown ===== */
      if (!this.contains(event.target)) {
        this.updateButtonStates();
        this.updateDropdownClasses(true);
        this.closeDropdown();
      }
    }

    closeDropdown() {
      /* ===== Close the dropdown by hiding the dropdown list ===== */
      setTimeout(() => {this.dropdownList.style.display = 'none'}, 150);
    }

    getVariantData(dropdownId) {
      return JSON.parse(this.getVariantDataElement(dropdownId).textContent);
    }

    getVariantDataElement(dropdownId) {
      return this.querySelector(`script[type="application/json"][data-resource="${dropdownId}"]`);
    }

    disconnectedCallback() {
      /* ===== Remove the event listeners when the component is removed from the DOM ===== */
      this.dropdownButton.removeEventListener('click', this.toggleDropdown);
      this.options.forEach(option => {
        option.removeEventListener('click', this.handleOptionClick);
        option.removeEventListener('keydown', this.handleOptionKeyDown);
      });

      this.dropdownList.removeEventListener('focusout', this.closeDropdownOnFocusOut);
      document.removeEventListener('click', this.onDocumentClick);
    }
  });
}

/******/ })()
;